var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7727 9.14792L23.6791 8.68255L19.7215 7.99113L22.0212 4.87978L21.7538 4.58726L18.371 6.20942L18.7989 1.90138L18.4513 1.70194L16.3922 5.18559L14.0791 0H13.678L14.2262 5.01274L8.41003 0.359003L7.91532 0.505263L12.3944 6.12964L3.5298 3.17784L3.12869 3.62992L11.044 8.13739L0.120329 9.04155L0 9.71967L11.3515 10.9562L1.88524 18.7878L2.28635 19.333L13.5577 13.2033L11.3248 24H12.0067L16.3253 13.8415L18.9593 21.7928L19.4273 21.4338L18.3443 13.3496L22.449 18.0033L22.7164 17.5778L19.5744 11.8072L23.9599 13.4294L24 12.9374L20.0691 10.0388L23.7727 9.14792Z",
    fill: "#FFBC0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.c315dd93c8781cbf7b0feeaf9f211718.svg";
export { ForwardRef as ReactComponent };